import React, { JSX, useState } from 'react';
import {
  ProfileIcon,
  SettingsIcon,
  MenuIcon,
  InboxIcon,
  GuidelineIcon,
  SVGGradient,
} from '../assets/svg/svg';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import { useNavigate } from 'react-router-dom';


type SettingItem = {
  label: string;
  screen: string;
  icon: string;
  status?: boolean;
};

const iconMap: Record<string, JSX.Element> = {
  person: <ProfileIcon size={22} />,
  security: <SettingsIcon size={22} />,
  check: <InboxIcon size={22} />,
  x: <InboxIcon size={22} color="#e74c3c" />,
  translate: <MenuIcon size={22} />,
  help: <GuidelineIcon size={22} />,
  payment: <SettingsIcon size={22} />,
  privacy: <SettingsIcon size={22} />,
  cookie: <MenuIcon size={22} />,
  safety: <GuidelineIcon size={22} />,
};

const sections: { title: string; items: SettingItem[] }[] = [
  {
    title: 'Account Center',
    items: [
      { label: 'Account Setting', screen: '/AccountSetting', icon: 'person', status: true },
      { label: 'Password & Security', screen: '/SecuritySettings', icon: 'security', status: true },
      { label: 'Verification', screen: '/Verification', icon: 'check', status: false },
    ],
  },
  {
    title: 'Preferences',
    items: [
      { label: 'Display Language', screen: '/Language', icon: 'translate' },
      { label: 'Dark mode', screen: '/DarkMode', icon: 'help' },
    ],
  },
  {
    title: 'Payments',
    items: [
      { label: 'Payment Methods', screen: '/Payments', icon: 'payment' },
      { label: 'Currency', screen: '/Currency', icon: 'payment' },
    ],
  },
  {
    title: 'Community & Legal',
    items: [
      { label: 'Terms of Service', screen: '/Terms', icon: 'privacy' },
      { label: 'Privacy Policy', screen: '/Privacy', icon: 'privacy' },
      { label: 'Cookie Policy', screen: '/Cookies', icon: 'cookie' },
      { label: 'Community Standards', screen: '/Community', icon: 'safety' },
      { label: 'About', screen: '/About', icon: 'help' },
    ],
  },
];

const SettingPrivacy: React.FC = () => {
  const [search, setSearch] = useState('');
  const user = useSelector((state: RootState) => state.auth.user);
const userId = user?.userId;
const navigate = useNavigate();


  const filteredSections = sections
    .map((section) => ({
      ...section,
      items: section.items.filter((item) =>
        item.label.toLowerCase().includes(search.toLowerCase())
      ),
    }))
    .filter((section) => section.items.length > 0);

  return (
    <div style={styles.wrapper}>
      <SVGGradient />
      <div style={styles.inner}>
        <input
          style={styles.searchInput}
          type="text"
          placeholder="Search Settings..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        {filteredSections.map((section, idx) => (
          <div key={idx} style={styles.section}>
            <p style={styles.sectionTitle}>{section.title}</p>
            <div style={styles.grid}>
              {section.items.map((item, index) => (
                <div
                  key={index}
                  style={styles.card}
                  onClick={() => {
                    if (userId && ['/AccountSetting', '/SecuritySettings', '/Verification', '/Payments'].includes(item.screen)) {
                      navigate(`${item.screen}/${userId}`);
                    } else {
                      navigate(item.screen);
                    }
                  }}
                                  >
                  <div style={styles.cardContent}>
                    {iconMap[item.icon] || <MenuIcon size={22} />}
                    <span style={styles.cardText}>{item.label}</span>
                  </div>
                  {item.status !== undefined &&
                    (item.status ? (
                      <InboxIcon size={18} color="#2ecc71" />
                    ) : (
                      <InboxIcon size={18} color="#e74c3c" />
                    ))}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SettingPrivacy;

const styles: { [key: string]: React.CSSProperties } = {
  wrapper: {
    backgroundColor: '#000',
    minHeight: '100vh',
    padding: '40px 16px',
    display: 'flex',
    justifyContent: 'center',
    color: '#fff',
  },
  inner: {
    width: '100%',
    maxWidth: 960,
  },
  searchInput: {
    backgroundColor: '#1a1a1a',
    color: '#fff',
    borderRadius: 12,
    padding: '12px 16px',
    marginBottom: 30,
    border: '1px solid #444',
    width: '90%',
    fontSize: 14,
  },
  section: {
    marginBottom: 40,
  },
  sectionTitle: {
    color: '#999',
    fontSize: 13,
    marginBottom: 16,
    fontWeight: 'bold',
    textTransform: 'uppercase',
    paddingLeft: 4,
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
    gap: 16,
  },
  card: {
    backgroundColor: '#111',
    borderRadius: 12,
    padding: '16px 18px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    border: '1px solid #1c1c1e',
  },
  cardContent: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
  },
  cardText: {
    fontSize: 15,
    fontWeight: 500,
  },
};
